import PropTypes from 'prop-types';
import MultiselectGrouped from 'Components/Molecules/MultiselectGrouped/MultiselectGrouped';
import Chip from 'Components/Molecules/Chip/Chip';
import clsx from 'clsx';
import { cn } from 'Utils/cn';
import { forwardRef } from 'react';

const SelectSingleTagMultipleTaxonomies = forwardRef(function SelectSingleTagMultipleTaxonomies(props, ref) {
    const { value, onChange, label, disabled, error, className, highlight, categories, taxonomies } = props;

    const optionsFormatted = categories.map((category) => ({
        ...category,
        label: category.name,
        className: clsx(category.parent_tag_id && 'pl-5'),
    }));

    const categoriesByTaxonomy = taxonomies
        .map((taxonomy) => ({
            groupId: taxonomy.id,
            label: taxonomy.name,
            items: optionsFormatted.filter((category) => category.taxonomy_id === taxonomy.id),
        }))
        .filter((group) => group.items.length > 0);

    const selectedTag = value ? categories.find((cat) => cat.id === value) : null;
    const optionsSelected = value ? [value] : [];

    const handleChange = (selectedIds) => {
        if (selectedIds.length === 0) {
            onChange(null);
            return;
        }

        const newId = selectedIds.find((id) => id !== value);
        if (newId) {
            onChange(newId);
        } else {
            onChange(null);
        }
    };

    return (
        <MultiselectGrouped
            ref={ref}
            disabled={disabled}
            enableClear={!!value}
            onClear={() => onChange(null)}
            floatLabel={label}
            label={
                selectedTag ? (
                    <Chip color={selectedTag.color} icon={selectedTag.icon}>
                        {selectedTag.name}
                    </Chip>
                ) : null
            }
            options={categoriesByTaxonomy}
            optionsSelected={optionsSelected}
            onChangeSelected={handleChange}
            className={cn('h-auto min-h-11 py-2', className)}
            error={error}
            highlight={highlight}
            renderOption={(option) => (
                <Chip key={option.id} color={option.color} icon={option.icon}>
                    {option.name}
                </Chip>
            )}
        />
    );
});

export default SelectSingleTagMultipleTaxonomies;

SelectSingleTagMultipleTaxonomies.propTypes = {
    disabled: PropTypes.bool,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    className: PropTypes.string,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    highlight: PropTypes.bool,
    categories: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            parent_tag_id: PropTypes.string,
            color: PropTypes.string,
            icon: PropTypes.node,
        }),
    ).isRequired,
    taxonomies: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
        }),
    ).isRequired,
};

